import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsTaxiForwardingContractDetails from "./contracts-taxi-forwarding-contract-details";
import ContractsTaxiForwardingContractDetailsParams from "./contracts-taxi-forwarding-contract-details-params";

const useContractsTaxiForwardingContractDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsTaxiForwardingContractDetails | null>(null);

  const load = async (
    params: ContractsTaxiForwardingContractDetailsParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiContractDetails =
        await contractsService.getTaxiForwardingContractDetails(params, signal);

      setData(taxiContractDetails);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useContractsTaxiForwardingContractDetails;
